<template>
  <div class="homapt-wrapper">
    <div class="container">
      <div class="row">
        <div class="col-lg-3">
          <user-subnav></user-subnav>
        </div>
        <div class="col-lg-9">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserSubnav from './UserSubnav.vue'

export default {
  components: {
    userSubnav: UserSubnav
  }
}
</script>

<style>
.homapt-wrapper {
  padding-top: 3rem;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/userProfile/UserProfile.vue